import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { TotalPerCategoryFilter } from './total-per-category-filter.model';
import { TotalPerCurrencyFilter } from './total-per-currency-filter.model';
import { TotalPerMonthFilter } from './total-per-month-filter.model';

export const ALL_YEARS: number = -1;
export const TOTAL_PER_YEAR_FILTER_SCHEMA = Object.freeze({
  YEAR: ALL_YEARS, // tax year
  TOTALS: List<TotalPerCurrencyFilter>([]),
  MONTHS: List<TotalPerMonthFilter>([]),
  CATEGORIES: List<TotalPerCategoryFilter>([]),
});
const RECORD = generateSchema(TOTAL_PER_YEAR_FILTER_SCHEMA);
const KEYS: any = generateKeys(TOTAL_PER_YEAR_FILTER_SCHEMA);

export class TotalPerYearFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.TOTALS,
        value: props.get(KEYS.TOTALS)
          ? this.totals.map((params) => new TotalPerCurrencyFilter(params))
          : List<TotalPerCurrencyFilter>([]),
      },
      {
        key: KEYS.MONTHS,
        value: props.get(KEYS.MONTHS)
          ? this.months.map((params) => new TotalPerMonthFilter(params))
          : List<TotalPerMonthFilter>([]),
      },
      {
        key: KEYS.CATEGORIES,
        value: props.get(KEYS.CATEGORIES)
          ? this.categories.map((params) => new TotalPerCategoryFilter(params))
          : List<TotalPerCategoryFilter>([]),
      },
    ]);

    return selfModel as TotalPerYearFilter;
  }

  get year(): number {
    return this.get(KEYS.YEAR);
  }

  get totals(): List<TotalPerCurrencyFilter> {
    return this.get(KEYS.TOTALS);
  }

  get months(): List<TotalPerMonthFilter> {
    return this.get(KEYS.MONTHS);
  }

  get categories(): List<TotalPerCategoryFilter> {
    return this.get(KEYS.CATEGORIES);
  }

  isAllYears(): boolean {
    return this.year === ALL_YEARS;
  }
}
